// extracted by mini-css-extract-plugin
export default {"removeButton":"ExtPersonLinks-module__removeButton___XWrMA"};